/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import {
  View,
  ScrollView,
  SafeAreaView,
  TouchableOpacity,
  StatusBar,
  BackHandler,
  Platform,
  LayoutAnimation,
  FlatList,
  Dimensions,
  Pressable
} from 'react-native'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Icon, QuickActionMenu, VFText } from '@vfgroup-oneplatform/foundation/Components'
import { Colors, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

// eslint-disable-next-line import/no-named-as-default
import WebView from 'react-native-webview'

import MigrationLottie from '../../Components/MigrationLottie'
import VfText from '../../Components/VfText'
import SelectGroup from '../../Components/SelectGroup'
import HorizontalLine from '../../Components/HorizontalLine'
import VFButton from '../../Components/VFButton'
import ProgressBar from '../../Components/ProgressBar'

import { getThemeImages } from '../../Themes'

import styles, { PMStyles } from './Refill.Styles'

import Modal from 'react-native-modal'

console.disableYellowBox = true
const BUNDLE_CONFLICT = 'bundle_conflict'
const cLoaderColors = {
  background: '#f3f3f3',
  foreground: '#ecebeb',
}

const SCREEN_OPTIONS = {
  home: {
    title: 'refill_title',
  },
  paymentOptions: {
    title: 'refill_title',
    containerStyle: styles.containerStyle,
    headerStyle: styles.headerStyle,
  },
  confirmPayment: {
    title: 'refill_confirm_header_title',
  },
  confirm: {
    title: 'refill_title',
  },
  error: {
    title: 'refill_title',
  },
  loading: {
    title: 'refill_title',
  },
  info: {
    title: 'refill_title_more_info',
  },
  overwrite: {
    title: 'refill_title',
  },
  success: {
    title: 'refill_title',
  },
}

const SCREENS = {
  home: 'home',
  paymentOptions: 'paymentOptions',
  confirmPayment: 'confirmPayment',
  confirm: 'confirm',
  error: 'error',
  loading: 'loading',
  info: 'info',
  overwrite: 'overwrite',
  success: 'success',
}

function Info({
  moreInfoUrl,
  setActiveScreen,
}) {
  return (
    <View style={styles.modal}>
      <ScrollView
        contentContainerStyle={styles.infoScrollContainer}
        style={styles.infoScroll}
        showsVerticalScrollIndicator={false}>
        <View style={styles.webView} onStartShouldSetResponder={() => true}>
          <WebView
            source={{ uri: moreInfoUrl }}
            startInLoadingState={true}
            renderLoading={() => (
              <View style={styles.modalContentWraper}>
                <MigrationLottie
                  source={require('./loaderE60000.json')}
                  style={styles.lottie}
                />
              </View>
            )}
          />
        </View>
      </ScrollView>
      <VFButton
        type="primary"
        title="refill_button_cancel"
        onPress={() => setActiveScreen(SCREENS.home)}
        style={styles.buttonSpace}
        disabled={false}
        isLoading={false}
        loadingTitle="refill_button_continue"
      />
    </View>
  )
}
Info.propTypes = {
  moreInfoUrl: PropTypes.string,
  setActiveScreen: PropTypes.func,
}

function Home({
  title,
  options,
  selected,
  setSelected,
  fromDate,
  toDate,
  dateFormat,
  visibleDateFormat,
  endDateFormat,
  balance,
  isContentLoading,
  language,
  recharge,
  resetStatusBar,
  closeModal,
  setActiveScreen,
  offerLoading,
}) {

  const { type, value = 0 } = options?.[selected] || {}
  let isDisabled = false, isRecharge = false, next
  const theme = useTheme()
  const themeImages = getThemeImages(theme.name)

  if (type !== 'activate_with_action') {
    isDisabled = selected === -1
    if (balance < parseFloat(value)) {
      isRecharge = true
    }
    next = () => setActiveScreen(SCREENS.confirm)
  } else {
    next = () => setActiveScreen(SCREENS.paymentOptions)
  }

  return (
    <View
      style={styles.modal}
      onStartShouldSetResponder={() => true}>
      <View style={styles.subHeaderContainer}>
        <VfText
          size="h3"
          weight="light"
          i18nKey={title}
          isLoading={offerLoading}
          style={styles.title}
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
          color={theme.colors.textColor}
        />
        <TouchableOpacity
          style={styles.moreInfoContainer}
          onPress={() => setActiveScreen(SCREENS.info)}>
          <VfText
            size="footnote"
            weight="regular"
            align="right"
            i18nKey="refill_label_more_info"
            color={Colors.vfRed}
            style={styles.infoLabel}
            isLoading={isContentLoading}
            loadingBackgroundColor={cLoaderColors.background}
            loadingForegroundColor={cLoaderColors.foreground}
          />
          <Icon
            source={themeImages.info}
            size={20}
            type="image"
            resizeMode="contain"
            style={styles.infoIcon}
          />
        </TouchableOpacity>
      </View>
      <ProgressBar
        usedLabel="refill_label_dates_used"
        totalLabel="refill_label_available_days"
        backgroundColor={Colors.tangerine}
        foregroundColor={Colors.ocean}
        startDate={fromDate}
        endDate={toDate}
        dateFormat={dateFormat}
        visibleDateFormat={visibleDateFormat}
        isLoading={offerLoading}
        isContentLoading={isContentLoading}
        language={language}
      />
      <HorizontalLine style={styles.separator} />
      <VfText
        size="h3"
        weight="light"
        i18nKey="refill_label_choose_amount"
        style={styles.mediumSpace}
        isLoading={isContentLoading}
        loadingBackgroundColor={cLoaderColors.background}
        loadingForegroundColor={cLoaderColors.foreground}
        color={theme.colors.textColor}
      />
      <SelectGroup
        options={options}
        selected={selected}
        setSelected={setSelected}
        containerStyle={styles.options}
        isLoading={offerLoading}
      />
      {Boolean(type) && type !== 'activate_with_action' && <>
        <VfText
          size="h3"
          weight="light"
          i18nKey="refill_label_payment_method"
          style={styles.smallSpace}
          isLoading={isContentLoading}
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
          color={theme.colors.textColor}
        />
        <View style={styles.airtimeContainer}>
          <VfText
            size="h5"
            weight="bold"
            i18nKey="refill_label_airtime"
            placeHolders={[balance]}
            isLoading={isContentLoading}
            loadingBackgroundColor={cLoaderColors.background}
            loadingForegroundColor={cLoaderColors.foreground}
            color={theme.colors.textColor}
          />
          <VfText
            size="h5"
            weight="bold"
            i18nKey="refill_currency"
            style={styles.currency}
            isLoading={isContentLoading}
            loadingBackgroundColor={cLoaderColors.background}
            loadingForegroundColor={cLoaderColors.foreground}
            color={theme.colors.textColor}
          />
        </View>
      </>}
      {isRecharge ? (
        <>
          <VfText
            size="footnote"
            weight="regular"
            i18nKey="refill_insufficient_airtime_description"
            placeHolders={['15.07.2020', '23.07.2020']}
            style={styles.xlargeSpace}
            isLoading={isContentLoading}
            loadingBackgroundColor={cLoaderColors.background}
            loadingForegroundColor={cLoaderColors.foreground}
            color={theme.colors.textColor}
          />
          <VFButton
            type="primary"
            title="refill_button_top_up"
            onPress={recharge}
            style={styles.confirmButton}
            disabled={false}
            isLoading={false}
            loadingTitle="refill_button_continue"
          />
        </>
      ) : (
        <>
          <VfText
            size="footnote"
            weight="regular"
            i18nKey="refill_bundle_availability_description"
            placeHolders={[
              moment(toDate, dateFormat).format(endDateFormat),
            ]}
            style={styles.xlargeSpace}
            isLoading={isContentLoading || offerLoading}
            loadingBackgroundColor={cLoaderColors.background}
            loadingForegroundColor={cLoaderColors.foreground}
            color={theme.colors.textColor}
          />
          <VFButton
            type="primary"
            title="refill_payment_option_next"
            onPress={next}
            style={styles.confirmButton}
            disabled={isDisabled}
            isLoading={false}
            loadingTitle="refill_payment_option_next"
          />
        </>
      )}
      {Dimensions.get('window').width > 700 && Platform.OS === 'web' ? null : <VFButton
        type="secondary"
        title="refill_button_cancel"
        onPress={() => closeModal()}
        style={styles.button}
        disabled={false}
        isLoading={false}
        loadingTitle="refill_button_continue"
      />}
    </View>
  )
}
Home.propTypes = {
  title: PropTypes.string,
  options: PropTypes.array,
  selected: PropTypes.number,
  setSelected: PropTypes.func,
  fromDate: PropTypes.string,
  toDate: PropTypes.string,
  dateFormat: PropTypes.string,
  visibleDateFormat: PropTypes.string,
  endDateFormat: PropTypes.string,
  balance: PropTypes.string,
  isContentLoading: PropTypes.bool,
  language: PropTypes.string,
  recharge: PropTypes.func,
  resetStatusBar: PropTypes.func,
  closeModal: PropTypes.func,
  setActiveScreen: PropTypes.func,
  offerLoading: PropTypes.bool,
}

function PaymentOption({
  icon,
  title,
  desc,
  isSelected,
  onPress,
  isContentLoading,
}) {
  const theme = useTheme()

  return (
    <View style={PMStyles['containerSelected_' + isSelected]}>
      <TouchableOpacity onPress={onPress} activeOpacity={0.5} style={PMStyles.touchable}>
        <Icon name={icon} type="image" size={24} resizeMode="contain" />
        <VfText
          size="h4"
          weight="bold"
          i18nKey={title}
          isLoading={isContentLoading}
          style={PMStyles.title}
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
          color={theme.colors.textColor}
        />
        <VfText
          i18nKey={desc}
          isLoading={isContentLoading}
          style={PMStyles.desc}
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
          color={theme.colors.textColor}
        />
      </TouchableOpacity>
    </View>
  )
}
PaymentOption.propTypes = {
  icon: PropTypes.any,
  title: PropTypes.string,
  desc: PropTypes.string,
  isSelected: PropTypes.bool,
  onPress: PropTypes.func,
  isContentLoading: PropTypes.bool,
}

function PaymentOptions({
  options,
  selected,
  balance,
  isContentLoading,
  msisdn,
  setActiveScreen,
  offerLoading,
  paymentMethod,
  setPaymentMethod,
}) {
  const theme = useTheme()
  const themeImages = getThemeImages(theme.name)
  const { desc, value = 0 } = options?.[selected] || {}

  const PAYMENT_OPTIONS = [
    {
      icon: themeImages.airtime,
      title: 'refill_payment_option_airtime',
      method: 'amount',
    },
    {
      icon: themeImages.bill,
      title: 'refill_payment_option_bill',
      method: 'bill',
    },
  ]

  const data = PAYMENT_OPTIONS.filter(element => {
    if (element.method === 'amount' && balance < parseFloat(value)) {
      return false
    }
    return true
  })
  const keyExtractor = (_, index) => 'paymentOption' + index
  const renderItem = ({ item, index }) => (
    <PaymentOption
      {...item}
      index={index}
      desc={item.method === 'bill' ? msisdn : desc}
      isSelected={item.method === paymentMethod}
      isContentLoading={isContentLoading}
      onPress={() => setPaymentMethod(item.method)}
    />
  )

  return (
    <View style={styles.modal}>
      <VfText
        size="h3"
        weight="light"
        i18nKey="refill_label_payment_options"
        isLoading={offerLoading}
        style={PMStyles.sectionTitle}
        loadingBackgroundColor={cLoaderColors.background}
        loadingForegroundColor={cLoaderColors.foreground}
        color={theme.colors.textColor}
      />
      <FlatList
        horizontal
        showsHorizontalScrollIndicator={false}
        data={data}
        keyExtractor={keyExtractor}
        renderItem={renderItem}
        snapToOffsets={[...Array(data.length)].map((_, i) => (i * 216))}
        contentContainerStyle={PMStyles.contentContainer}
      />
      <HorizontalLine style={PMStyles.separator} />
      <VFButton
        type="primary"
        title="refill_payment_option_next"
        onPress={() => setActiveScreen(paymentMethod === 'bill' ? SCREENS.confirmPayment : SCREENS.confirm)}
        style={PMStyles.confirmButton}
        disabled={!paymentMethod}
        isLoading={false}
        loadingTitle="refill_payment_option_next"
      />
    </View>
  )
}
PaymentOptions.propTypes = {
  options: PropTypes.array,
  selected: PropTypes.number,
  balance: PropTypes.string,
  isContentLoading: PropTypes.bool,
  msisdn: PropTypes.string,
  setActiveScreen: PropTypes.func,
  offerLoading: PropTypes.bool,
  paymentMethod: PropTypes.bool,
  setPaymentMethod: PropTypes.func,
}

function ConfirmPayment({
  options,
  selected,
  setActiveScreen,
  offerLoading,
  paymentMethod,
  paymentActions,
  activateOffer,
  setError,
}) {
  const { desc } = options?.[selected] || {}
  const theme = useTheme()
  return (
    <View style={styles.modal}>
      <VfText
        size="h3"
        weight="light"
        i18nKey="refill_confirm_title"
        isLoading={offerLoading}
        style={styles.sectionTitle}
        loadingBackgroundColor={cLoaderColors.background}
        loadingForegroundColor={cLoaderColors.foreground}
        color={theme.colors.textColor}
      />
      <View style={{ flexDirection: 'row', alignItems: 'baseline', marginVertical: 8 }}>
        <VfText
          size="footnote"
          i18nKey="refill_confirm_cost"
          style={{ lineHeight: 22 }}
          color={theme.colors.textColor}
        />
        <VfText
          weight="bold"
          i18nKey={desc}
          color={theme.colors.textColor}
        />
      </View>
      <VfText
        i18nKey="refill_confirm_desc"
        style={{ marginTop: 8, marginBottom: 32 }}

      />
      <VFButton
        type="primary"
        title="refill_button_confirm"
        style={styles.buttonSpace}
        onPress={() => {
          activateOffer?.(paymentActions[paymentMethod], {
            onSuccess: response => {
              if (response.status === BUNDLE_CONFLICT) {
                setActiveScreen(SCREENS.overwrite)
              } else {
                setActiveScreen(SCREENS.success)
              }
            },
            onError: e => {
              setError(e || '')
              setActiveScreen(SCREENS.error)
            },
          })
        }}
      />
      <VFButton
        type="secondary"
        title="refill_button_cancel"
        onPress={() => setActiveScreen(SCREENS.home)}
        style={styles.secondaryButton}
      />

    </View>
  )
}
ConfirmPayment.propTypes = {
  options: PropTypes.array,
  selected: PropTypes.number,
  setActiveScreen: PropTypes.func,
  offerLoading: PropTypes.bool,
  paymentMethod: PropTypes.bool,
  paymentActions: PropTypes.object,
  activateOffer: PropTypes.func,
  setError: PropTypes.func,
}


function Confirm({
  options,
  selected,
  activateOffer,
  isContentLoading,
  setActiveScreen,
  setError,
  paymentMethod,
  paymentActions,
}) {
  const theme = useTheme()
  const themeImages = getThemeImages(theme.name)
  return (
    <View
      style={styles.modal}
      onStartShouldSetResponder={() => true}>
      <View style={styles.modalContentWraper}>
        <Icon
          name={themeImages.recharge}
          size={95}
          type="image"
          resizeMode="contain"
        />
        <VfText
          weight="bold"
          size="h3"
          align="center"
          style={styles.verticalSpacing}
          isLoading={isContentLoading}
          i18nKey="refill_purchase_product_confirm"
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
          color={theme.colors.textColor}
        />
        <VfText
          align="center"
          size="h5"
          isLoading={isContentLoading}
          i18nKey="refill_purchased_package_description"
          placeHolders={[options?.[selected]?.title, options?.[selected]?.desc]}
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
          color={theme.colors.textColor}
        />
      </View>

      <VFButton
        type="primary"
        title="refill_button_yes"
        style={styles.buttonSpace}
        onPress={() => {
          activateOffer?.(paymentActions[paymentMethod], {
            onSuccess: response => {
              if (response.status === BUNDLE_CONFLICT) {
                setActiveScreen(SCREENS.overwrite)
              } else {
                setActiveScreen(SCREENS.success)
              }
            },
            onError: e => {
              setError(e || '')
              setActiveScreen(SCREENS.error)
            },
          })
        }}
      />
      <VFButton
        type="secondary"
        title="refill_button_cancel"
        onPress={() => setActiveScreen(SCREENS.home)}
        style={styles.secondaryButton}
      />
    </View>
  )
}
Confirm.propTypes = {
  options: PropTypes.array,
  selected: PropTypes.number,
  activateOffer: PropTypes.func,
  isContentLoading: PropTypes.bool,
  setActiveScreen: PropTypes.func,
  setError: PropTypes.func,
  paymentMethod: PropTypes.bool,
  paymentActions: PropTypes.object,
}

function Overwrite({
  options,
  selected,
  activateOffer,
  isContentLoading,
  setActiveScreen,
  setError,
  paymentMethod,
  paymentActions,
}) {
  const theme = useTheme()
  const themeImages = getThemeImages(theme.name)
  return (
    <View
      style={styles.modal}
      onStartShouldSetResponder={() => true}>
      <View style={styles.modalContentWraper}>
        <Icon
          name={themeImages.openBox}
          size={95}
          type="image"
          resizeMode="contain"
        />
        <VfText
          weight="bold"
          size="h3"
          align="center"
          style={styles.verticalSpacing}
          isLoading={isContentLoading}
          i18nKey="refill_overwrite_bundle_confirm"
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
          color={theme.colors.textColor}
        />
        <VfText
          align="center"
          size="h5"
          isLoading={isContentLoading}
          i18nKey="refill_purchased_package_description"
          placeHolders={[options[selected].title, options[selected].desc]}
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
          color={theme.colors.textColor}
        />
      </View>

      <VFButton
        type="primary"
        title="refill_button_yes"
        style={styles.buttonSpace}
        onPress={() => {
          activateOffer?.(paymentActions[paymentMethod], {
            onSuccess: () => setActiveScreen(SCREENS.success),
            onError: e => {
              setError(e || '')
              setActiveScreen(SCREENS.error)
            },
          })
        }}
      />
      <VFButton
        type="secondary"
        title="refill_button_cancel"
        onPress={() => setActiveScreen(SCREENS.home)}
        style={styles.secondaryButton}
      />
    </View>
  )
}
Overwrite.propTypes = {
  options: PropTypes.array,
  selected: PropTypes.number,
  activateOffer: PropTypes.func,
  isContentLoading: PropTypes.bool,
  setActiveScreen: PropTypes.func,
  setError: PropTypes.func,
  paymentMethod: PropTypes.bool,
  paymentActions: PropTypes.object,
}

function Loading() {
  return (
    <View
      style={styles.modal}
      onStartShouldSetResponder={() => true}>
      <View style={styles.modalContentWraper}>
        <MigrationLottie
          source={require('./loaderE60000.json')}
          style={styles.lottie}
        />
      </View>
    </View>
  )
}

function Success({
  options,
  selected,
  isContentLoading,
  closeModal,
  setActiveScreen,
}) {
  const theme = useTheme()
  const themeImages = getThemeImages(theme.name)
  return (
    <View
      style={styles.modal}
      onStartShouldSetResponder={() => true}>
      <View style={styles.modalContentWraper}>
        <Icon
          name={themeImages.tick}
          size={95}
          type="image"
          resizeMode="contain"
        />
        <VfText
          weight="bold"
          size="h3"
          align="center"
          style={styles.verticalSpacing}
          isLoading={isContentLoading}
          i18nKey="refill_label_congratulations"
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
          color={theme.colors.textColor}
        />
        <VfText
          align="center"
          size="h5"
          isLoading={isContentLoading}
          i18nKey="refill_purchased_package_information"
          placeHolders={[options[selected].title]}
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
          color={theme.colors.textColor}
        />
      </View>

      <VFButton
        type="primary"
        title="refill_button_continue"
        onPress={() => {
          closeModal()
          setActiveScreen(SCREENS.home)
        }}
      />
    </View>
  )
}
Success.propTypes = {
  options: PropTypes.array,
  selected: PropTypes.number,
  isContentLoading: PropTypes.bool,
  closeModal: PropTypes.func,
  setActiveScreen: PropTypes.func,
}

function Error({
  activationLoading,
  isContentLoading,
  setActiveScreen,
  offerLoading,
  error,
}) {
  const theme = useTheme()
  const themeImages = getThemeImages(theme.name)
  return (
    <View
      style={styles.modal}
      onStartShouldSetResponder={() => true}>
      <View style={styles.modalContentWraper}>
        <Icon
          name={themeImages.error}
          size={95}
          type="image"
          resizeMode="contain"
        />
        <VfText
          weight="bold"
          size="h3"
          align="center"
          style={styles.verticalSpacing}
          isLoading={isContentLoading}
          i18nKey="refill_label_problem"
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
          color={theme.colors.textColor}
        />
        <VfText
          align="center"
          isLoading={activationLoading || offerLoading}
          i18nKey={error}
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
          color={theme.colors.textColor}
        />
      </View>
      <VFButton
        type="primary"
        title="refill_button_go_back"
        onPress={() => setActiveScreen(SCREENS.home)}
      />
    </View>
  )
}
Error.propTypes = {
  activationLoading: PropTypes.bool,
  isContentLoading: PropTypes.bool,
  setActiveScreen: PropTypes.func,
  offerLoading: PropTypes.bool,
  error: PropTypes.string,
}

const SCREEN_COMPONENTS = {
  info: Info,
  home: Home,
  paymentOptions: PaymentOptions,
  confirmPayment: ConfirmPayment,
  confirm: Confirm,
  overwrite: Overwrite,
  loading: Loading,
  success: Success,
  error: Error,
}

function Refill(props) {

  const {
    title,
    options,
    selected,
    setSelected,
    getOfferDetails,
    fromDate,
    toDate,
    dateFormat,
    visibleDateFormat,
    endDateFormat,
    balance,
    activateOffer,
    activationLoading,
    moreInfoUrl,
    isContentLoading,
    isVisible,
    toggleModal,
    language,
    recharge,
    msisdn,
  } = props

  const [activeScreen, changeActiveScreen] = useState(SCREENS.home)
  const [offerLoading, setOfferLoading] = useState(true)
  const [error, setError] = useState('')
  const [paymentMethod, setPaymentMethod] = useState()
  const paymentActions = {
    amount: 'ADD',
    bill: 'ADD_WITH_BILL',
  }

  const setActiveScreen = screen => {
    // LayoutAnimation.configureNext(LayoutAnimation.create(
    //   120,
    //   LayoutAnimation.Types.linear,
    //   LayoutAnimation.Properties.scaleXY
    // ))
    changeActiveScreen(screen)
  }

  const resetStatusBar = () => {
    if (Platform.OS === 'android') {
      StatusBar.setBarStyle('light-content', true)
      StatusBar.setBackgroundColor(Colors.thinDark, true)
      StatusBar.setTranslucent(false)
    } else if (Platform.OS === 'ios') {
      StatusBar.setBarStyle('dark-content', true)
    }
  }

  useEffect(() => {
    getOfferDetails({
      onSuccess: () => setOfferLoading(false),
      onError: e => {
        setError(e || '')
        setActiveScreen(SCREENS.error)
        setOfferLoading(false)
      },
    })
    resetStatusBar()
    const backAction = () => {
      resetStatusBar()
      return false
    }
    const backHandler = BackHandler.addEventListener(
      'hardwareBackPress',
      backAction
    )
    return () => backHandler.remove()
  }, [])

  const closeModal = () => {
    resetStatusBar()
    toggleModal()
  }
  const ActivationStep = activationLoading ? SCREEN_COMPONENTS.loading : SCREEN_COMPONENTS[activeScreen]
  const theme = useTheme()
  const themeImages = getThemeImages(theme.name)

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <Modal
        isVisible={isVisible}
        title={SCREEN_OPTIONS[activeScreen].title}
        containerStyle={SCREEN_OPTIONS[activeScreen].containerStyle}
        headerStyle={SCREEN_OPTIONS[activeScreen].headerStyle}
      >
        <View
          style={{
            minWidth: '650px',
            maxWidth: '650px',
            height: 'auto',
            backgroundColor: theme.colors.backgroundColor,
            margin: 'auto',
            paddingHorizontal: '50px',
            paddingVertical: '20px',
            borderRadius: '7px'
          }}
          onStartShouldSetResponder={() => true}
        >
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between'
            }}
          >
            <VFText
              i18nKey="refill_title"
              style={{ fontSize: '20px', fontWeight: 700 }}
            />
            <Pressable
              onPress={() => {
                closeModal()
              }}
            >
              <Icon type="image" name={themeImages.close} size={24} style={{ tintColor: theme.colors.textColor }} />
            </Pressable>
          </View>
          <ActivationStep
            title={title}
            options={options}
            selected={selected}
            setSelected={setSelected}
            getOfferDetails={getOfferDetails}
            fromDate={fromDate}
            toDate={toDate}
            dateFormat={dateFormat}
            visibleDateFormat={visibleDateFormat}
            endDateFormat={endDateFormat}
            balance={balance}
            activateOffer={activateOffer}
            activationLoading={activationLoading}
            moreInfoUrl={moreInfoUrl}
            isContentLoading={isContentLoading}
            isVisible={isVisible}
            toggleModal={toggleModal}
            language={language}
            recharge={recharge}
            msisdn={msisdn}
            resetStatusBar={resetStatusBar}
            closeModal={closeModal}
            setActiveScreen={setActiveScreen}
            offerLoading={offerLoading}
            error={error}
            setError={setError}
            paymentMethod={paymentMethod}
            setPaymentMethod={setPaymentMethod}
            paymentActions={paymentActions}
          />
        </View>
      </Modal>
    )
  }
  return (
    <SafeAreaView style={styles.container}>
      <QuickActionMenu
        isVisible={isVisible}
        toggleModal={closeModal}
        type="secondary"
        title={SCREEN_OPTIONS[activeScreen].title}
        containerStyle={SCREEN_OPTIONS[activeScreen].containerStyle}
        headerStyle={SCREEN_OPTIONS[activeScreen].headerStyle}
      >
        <ActivationStep
          title={title}
          options={options}
          selected={selected}
          setSelected={setSelected}
          getOfferDetails={getOfferDetails}
          fromDate={fromDate}
          toDate={toDate}
          dateFormat={dateFormat}
          visibleDateFormat={visibleDateFormat}
          endDateFormat={endDateFormat}
          balance={balance}
          activateOffer={activateOffer}
          activationLoading={activationLoading}
          moreInfoUrl={moreInfoUrl}
          isContentLoading={isContentLoading}
          isVisible={isVisible}
          toggleModal={toggleModal}
          language={language}
          recharge={recharge}
          msisdn={msisdn}
          resetStatusBar={resetStatusBar}
          closeModal={closeModal}
          setActiveScreen={setActiveScreen}
          offerLoading={offerLoading}
          error={error}
          setError={setError}
          paymentMethod={paymentMethod}
          setPaymentMethod={setPaymentMethod}
          paymentActions={paymentActions}
        />
      </QuickActionMenu>
    </SafeAreaView>
  )
}

Refill.defaultProps = {}

Refill.propTypes = {
  title: PropTypes.string,
  options: PropTypes.array,
  selected: PropTypes.number,
  setSelected: PropTypes.func,
  getOfferDetails: PropTypes.func,
  fromDate: PropTypes.string,
  toDate: PropTypes.string,
  dateFormat: PropTypes.string,
  visibleDateFormat: PropTypes.string,
  endDateFormat: PropTypes.string,
  balance: PropTypes.string,
  activateOffer: PropTypes.func,
  activationStatus: PropTypes.string,
  activationLoading: PropTypes.bool,
  moreInfoUrl: PropTypes.string,
  isContentLoading: PropTypes.bool,
  isVisible: PropTypes.bool,
  toggleModal: PropTypes.func,
  language: PropTypes.string,
  recharge: PropTypes.func,
  msisdn: PropTypes.string,
}

export default Refill
